import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, message, Button, Select } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';


const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};


class SetAccountStatusDialog extends Component {

    componentDidUpdate() {
        const {
            batchSetAccountStatusActionStatus,
        } = this.props;
        if(batchSetAccountStatusActionStatus === ACTION_STATUS.SUCCESS) {
            message.success('Batch Set Account Status succeeded');
            this.props.initBatchSetAccountStatusActionStatus();
            this.props.resetSetAccountStatusDialog();
            const {
                id,
                employee,
            } = this.props.personalAccountQueryFields;
            const param = {
                id,
                employee,
                approvalStatus: '',
                needHoldingData: 'true',
                source: 'Admin',
            }
            this.props.loadPersonalAccount(param);
        }
        if(batchSetAccountStatusActionStatus === ACTION_STATUS.ERROR) {
            this.props.initBatchSetAccountStatusActionStatus();
        }
    }


    submitSetAccountStatus = () => {
        const {
            fields,
        } = this.props.setAccountStatusModal;
        const {
            accountIds,
            accountStatus,
            comments,
        } = fields;

        if(!accountIds || accountIds.length === 0) {
            message.warn('Please select at least one account');
            return;
        }

        Modal.confirm({
            title: 'Are you sure to set Account Status to ' + accountStatus + ' for ' + accountIds.length + ' account(s)?',
            onOk: () => {
                this.props.batchSetAccountStatus({
                    accountIds,
                    accountStatus,
                    comments,
                });
            }
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            setAccountStatusModal,
            batchSetAccountStatusActionStatus,
        } = this.props;
        const {
            isOpened,
            respErrMsg,
            fields,
        } = setAccountStatusModal;
        const {
            accountIds,
            accountStatus,
            comments,
        } = fields;

        const modalTitle = 'Set Account Status';
        const isSubmitLoading = batchSetAccountStatusActionStatus === ACTION_STATUS.LOGINING;
        const selectedCount = accountIds ? accountIds.length : 0;

        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={800}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetSetAccountStatusDialog()}
                    footer={[
                        <Button key="Cancel" onClick={() => this.props.resetSetAccountStatusDialog() }>
                          Cancel
                        </Button>,
                        <Button key="Submit" type="primary" loading={isSubmitLoading} onClick={() => this.submitSetAccountStatus() }>
                          Submit
                        </Button>,
                    ]}
                >
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ fontWeight: 'bold' }}>Selected Accounts: {selectedCount}</span>
                    </div>
                    <Form layout="horizontal">

                        <Row gutter={24}>
                             <Col span={24}>
                                <FormItem {...formItemLayout} label="accountStatus">
                                    {getFieldDecorator('accountStatus', {
                                        initialValue: accountStatus || 'Invalid',
                                        rules: [{
                                            required: true,
                                            message: 'Please select account status',
                                        }],
                                        })(
                                        <Select
                                            placeholder='accountStatus'
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.props.onSetAccountStatusInputChange({ name: 'accountStatus', value: val })
                                        }}>
                                            <Option key={'Valid'}>{'Valid'}</Option>
                                            <Option key={'Invalid'}>{'Invalid'}</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                             <Col span={24}>
                                <FormItem {...formItemLayout} label="comments">
                                    {getFieldDecorator('comments', {
                                        initialValue: comments,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea
                                            style={{ width: 300, marginLeft: 10 }}
                                            rows={4}
                                            placeholder='comments'
                                            onChange={(e) => {
                                                this.props.onSetAccountStatusInputChange({ name: 'comments', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                    </Form>
                    {
                        !!respErrMsg &&
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{ respErrMsg }</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }

}


const SetAccountStatusDialogForm = Form.create({ name: 'SetAccountStatusDialog' })(SetAccountStatusDialog);
export default SetAccountStatusDialogForm;
